import React, { Component } from "react";

import Unity, { UnityContent } from "react-unity-webgl";

class GameWebGL extends Component {
	constructor(props) {
		super(props);

		let gameName = this.props.game;

		this.unityContent = new UnityContent(
			`${gameName}/Build/${gameName}.json`,
			`${gameName}/Build/UnityLoader.js`
		);

		console.log(this.props);
	}

	render() {
		return (
			<Unity unityContent={this.unityContent}
			/>
		);
	}
}

export default GameWebGL;